'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export const CircleProgressText = forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx("div", { ref: ref, ...props, className: cn('absolute start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-body-4 font-medium text-primary-500', className), children: children }));
});
CircleProgressText.displayName = 'CircleProgressText';
